// ====================================================================
// ziven-theme-aura v0.2.3 modifyHeaderSecondary.js
// ====================================================================
//
// 桌面端 (>= 992px) HeaderSecondary 注入 "发布主题" 蓝底方按钮
// 跟 ziven.ski 1.8 真实 1:1 (Playwright 调研):
//   - 位置: HeaderSecondary items priority 50 (在 search(30) 之前)
//   - 样式: Button--primary, 92x34, 蓝底 rgb(75, 147, 209), 方角 4px
//   - icon: fas fa-edit (跟 ziven.ski 一致)
//   - 文字: "发布主题" (跟 ziven.ski 一致)
//
// 辉哥 15:10 拍板:
//   - 桌面端 sidebar 容器隐藏 (CSS display: none, 代码保留)
//   - header-secondary 加 "发布主题" 蓝底方按钮 (跟 ziven.ski 真实一致)
//   - App-content 顶部 "发布讨论" 按钮保留
//   - 移动端不动 (drawer 模式保持现状)
//
// 关键: 动态加载 vendor DiscussionComposer 必须用 `flarum.reg.asyncModuleImport`,
// 不能直接 `import()` 因为 ziven-theme-aura 是独立 bundle, 不能 cross-load vendor chunks.
// 参考: vendor IndexSidebar.newDiscussionAction() 写法
// ====================================================================

import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
export default function modifyHeaderSecondary() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    // priority 50 = 在 search(30) 之前, 跟 ziven.ski 真实位置一致
    items.add('ziven-aura-new-discussion', m(Button, {
      icon: "fas fa-edit",
      className: "Button Button--primary ziven-aura-new-discussion",
      itemClassName: "App-primaryControl",
      "aria-label": app.translator.trans('ziiven-theme-aura.forum.new_discussion'),
      onclick: () => {
        // 跟 vendor IndexSidebar.newDiscussionAction() 一样的逻辑
        // 关键: 动态加载要用 flarum.reg.asyncModuleImport 跨 bundle 加载 vendor chunk
        if (app.session.user) {
          app.composer.load(() => app.registry.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
            user: app.session.user
          }).then(() => app.composer.show());
        } else {
          app.modal.show(() => app.registry.asyncModuleImport('flarum/forum/components/LogInModal'));
        }
      }
    }, app.translator.trans('ziiven-theme-aura.forum.new_discussion')), 50);
  });
}